import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import Sidebar from "./sidebar";
import axios from "axios";
import { API_URL } from "../components/api";
import "./navbar.css";
import {
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import ThemeModeContext from "../context/ThemeModeContext";
import LanguageContext from "../context/LanguageContext";

const Header = () => {
  const { user, logoutUser } = useContext(AuthContext);
  const { mode, toggleMode } = useContext(ThemeModeContext);
  const {
    language,
    direction,
    setLanguage,
    t,
  } = useContext(LanguageContext);
  const [data, setData] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(
    () => localStorage.getItem("sidebarOpen") === "true"
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const [showChangeWinboxPasswordModal, setShowChangeWinboxPasswordModal] =
    useState(false);
  const [winboxPassword, setWinboxPassword] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(
          `${API_URL}/administration/dealers/info/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200) {
          setData(response.data[0]);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [user.username]);

  const openSidebar = (e) => {
    e.stopPropagation();
    setSidebarOpen(true);
    localStorage.setItem("sidebarOpen", "true");
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    localStorage.setItem("sidebarOpen", "false");
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    setShowChangePasswordModal(true);
    handleMenuClose();
  };

  const handleChangeWinboxPassword = () => {
    setShowChangeWinboxPasswordModal(true);
    handleMenuClose();
  };

  const handleSubmitPasswordChange = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.post(
        `${API_URL}/administration/changepassword/`,
        {
          username: user.username,
          new_password: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      console.log(response);
      // Close the modal after successful password change
      setShowChangePasswordModal(false);
      // Optionally, you might want to handle any additional actions after changing the password
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitWinboxPasswordChange = async () => {
    try {
      // Validate password length (must be at least 8 characters)
      if (winboxPassword.length < 8) {
        alert(t("header.passwordMinimum"));
        return;
      }

      // Ensure password contains at least one uppercase letter, one number, and one special character
      const passwordPattern =
        /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

      if (!passwordPattern.test(winboxPassword)) {
        alert(t("header.passwordRules"));
        return;
      }

      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.post(
        `${API_URL}/radius/winbox/user/changepassword/`, // Update this endpoint
        {
          username: user.username,
          new_password: winboxPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      console.log(response);
      setShowChangeWinboxPasswordModal(false);
      setWinboxPassword("");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="nav" dir={direction}>
      <div className="nav-left">
        <button className="btn hamburger" onClick={openSidebar}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </button>
        <h3 className="brand-title">
          {t("header.brand")}
        </h3>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleMenuClose}>{data.company_name}</MenuItem>
          <MenuItem onClick={handleChangePassword}>
            {t("header.changePassword")}
          </MenuItem>
          <MenuItem onClick={handleChangeWinboxPassword}>
            {t("header.changeWinboxPassword")}
          </MenuItem>
        </Menu>
      </div>
      <div className="nav-right">
        <div
          className="language-toggle"
          role="group"
          aria-label={t("header.language")}
        >
          <button
            type="button"
            className={
              language === "en"
                ? "language-option active"
                : "language-option"
            }
            onClick={() => setLanguage("en")}
            aria-pressed={language === "en"}
          >
            EN
          </button>
          <span
            className="language-divider"
            aria-hidden="true"
          >
            |
          </span>
          <button
            type="button"
            className={
              language === "ar"
                ? "language-option active"
                : "language-option"
            }
            onClick={() => setLanguage("ar")}
            aria-pressed={language === "ar"}
          >
            AR
          </button>
        </div>
        <Tooltip
          title={
            mode === "dark"
              ? t("header.switchToLight")
              : t("header.switchToDark")
          }
        >
          <IconButton
            className="theme-toggle"
            onClick={toggleMode}
            aria-label={
              mode === "dark"
                ? t("header.switchToLight")
                : t("header.switchToDark")
            }
          >
            {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Tooltip>
        <h5
          style={{ marginTop: "15px", cursor: "pointer" }}
          onClick={handleMenuClick}
        >
          {t("header.hello", {
            username: user.username,
          })}
        </h5>
        {user ? (
          <div className="logout" onClick={logoutUser}>
            <h5>{t("header.logout")}</h5>
          </div>
        ) : (
          <Link to="/login">
            {t("header.login")}
          </Link>
        )}
      </div>

      <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />

      {/* Change Password Modal */}
      <Dialog
        open={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
      >
        <DialogTitle>
          {t("header.changePassword")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("header.enterNewPassword")}
          </DialogContentText>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="form-control"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowChangePasswordModal(false)}>
            {t("common.cancel")}
          </Button>
          <Button onClick={handleSubmitPasswordChange} autoFocus>
            {t("common.save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Change OSS Winbox Password Modal */}
      <Dialog
        open={showChangeWinboxPasswordModal}
        onClose={() => setShowChangeWinboxPasswordModal(false)}
      >
        <DialogTitle>
          {t("header.changeWinboxPassword")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("header.enterWinboxDetails")}
          </DialogContentText>

          <input
            type="password"
            placeholder={t("header.newPassword")}
            value={winboxPassword}
            onChange={(e) => setWinboxPassword(e.target.value)}
            className="form-control"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowChangeWinboxPasswordModal(false)}>
            {t("common.cancel")}
          </Button>
          <Button onClick={handleSubmitWinboxPasswordChange} autoFocus>
            {t("common.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Header;
